<template>
  <component :is="wizardComponent" />
</template>

<script>
import WizardView from './WizardView.vue';

export default {
    computed: {
        wizardComponent() {
            return WizardView;
        },
    },
};
</script>
